import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ProgressBar } from 'ui-components/components/progress-bar';
import FailedValidationBatchNotification from '../../../batches/failed-batch-notifications/failed-validation-notification';
import { validateBatchesRetry } from '../../../../store/batches/purchase/batches.purchase.actions';
import { retryValidation } from '../../../../store/bulk/purchase/bulk.purchase.actions';
import { VALIDATION_TIMEOUT_ERROR } from '../../../../store/bulk/bulk-error-types';
import { LabelBatchHeader } from '../header';
import style from './style.module.less';
import sharedStyle from '../style.module.less';

export const LabelBatchValidating = ({ jobGuid, batchId, batchName = '', totalLabels = 0, modalFrameworkMethods, error }) => {
  const { closeModal } = modalFrameworkMethods;
  const dispatch = useDispatch();

  const onRetry = useCallback(() => {
    const retryAction = jobGuid ? retryValidation() : validateBatchesRetry(batchId);
    dispatch(retryAction);
  }, [jobGuid, batchId, dispatch]);
  return (
    <>
      <ModalHeader className={sharedStyle['batch-processing-modal-header']} closeModal={closeModal}>
        <FormattedMessage defaultMessage='Label Batch Status: Validating' description='batchProcessingModal.validatingTitle' id='/FcZNP' />
      </ModalHeader>
      <ModalBody className={classNames(sharedStyle['batch-processing-modal-body'], style['batch-validation-modal-body'])}>
        <div className={style['batch-validating']}>
          <LabelBatchHeader batchName={batchName} totalLabels={totalLabels} />
          <div className={style['progress-wrap']}>
            <div className={style['validating-message']}>
              <FormattedMessage
                defaultMessage='Validating {totalLabels} Labels'
                description='batchValidating.totalLabelsValidating'
                id='DXiRir'
                values={{ totalLabels }}
              />
            </div>
            <ProgressBar indefiniteProgress={!error} percentageComplete={error ? 0 : undefined} theme='create' />
          </div>
        </div>
        {error === VALIDATION_TIMEOUT_ERROR ? <FailedValidationBatchNotification onRetry={onRetry} /> : null}
      </ModalBody>
    </>
  );
};

LabelBatchValidating.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  batchName: PropTypes.string,
  totalLabels: PropTypes.number,
  error: PropTypes.string,
  jobGuid: PropTypes.string,
  batchId: PropTypes.string,
};
